<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>For Mavis Haut,</span></p>
<p class="ded1"><span>who so often sees to the roots of what I write</span></p>
<p class="ded1"><span>while I only swing through the branches</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?32281ac0